import { Component } from '@angular/core';
import { INoRowsOverlayAngularComp } from 'ag-grid-angular';
import { ILoadingOverlayParams } from 'ag-grid-enterprise';
import { Observable } from 'rxjs';

export interface ICustomOverlayNoRowsProps extends ILoadingOverlayParams {
  noRowsMessageFunc?: () => string;
  noRowsMessage$?: Observable<string>;
}

@Component({
    selector: 'app-overlay-no-rows',
    templateUrl: './overlay-no-rows.component.html',
    styleUrls: ['./overlay-no-rows.component.scss'],
    standalone: false
})
export class CustomOverlayNoRowsComponent implements INoRowsOverlayAngularComp {
  public noRowsMessage$?: Observable<string>;
  public noRowsMessageFunc = () =>
    'The search performed did not find any data.';

  agInit(params: ICustomOverlayNoRowsProps): void {
    const { noRowsMessageFunc, noRowsMessage$ } = params;
    if (noRowsMessageFunc) {
      this.noRowsMessageFunc = noRowsMessageFunc;
    }
    this.noRowsMessage$ = noRowsMessage$;
  }
}
